var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiscountLabel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.02788 10.9501C1.91918 11.6023 2.13216 12.2669 2.59973 12.7345L11.2655 21.4003C12.0651 22.1999 13.3616 22.1999 14.1612 21.4003L21.4003 14.1612C22.1999 13.3616 22.1999 12.0651 21.4003 11.2655L12.7345 2.59973C12.2669 2.13216 11.6023 1.91918 10.9501 2.02788L4.74511 3.06204C3.88213 3.20588 3.20588 3.88213 3.06204 4.74511L2.02788 10.9501ZM9 10.5C8.17157 10.5 7.5 9.82843 7.5 9C7.5 8.17157 8.17157 7.5 9 7.5C9.82843 7.5 10.5 8.17157 10.5 9C10.5 9.82843 9.82843 10.5 9 10.5ZM15.0303 7.96967C15.3232 8.26256 15.3232 8.73744 15.0303 9.03033L9.03033 15.0303C8.73744 15.3232 8.26256 15.3232 7.96967 15.0303C7.67678 14.7374 7.67678 14.2626 7.96967 13.9697L13.9697 7.96967C14.2626 7.67678 14.7374 7.67678 15.0303 7.96967ZM14 15.5C13.1716 15.5 12.5 14.8284 12.5 14C12.5 13.1716 13.1716 12.5 14 12.5C14.8284 12.5 15.5 13.1716 15.5 14C15.5 14.8284 14.8284 15.5 14 15.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscountLabel);
export default __webpack_public_path__ + "static/media/discount-label.92189c02e0e0476ba9ad9791879464db.svg";
export { ForwardRef as ReactComponent };